/* functions to store gclid in Local Storage so it can be passed to hidden Marketo form field 
    * code adapted from https://jsfiddle.net/r7smvc4j/
*/
function getParam(p) {
    //var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    //return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const param = urlParams.get(p);
    return param;
}

function getExpiryRecord(value) {
    var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

    var expiryDate = new Date().getTime() + expiryPeriod;
    return {
        value: value,
        expiryDate: expiryDate
    };
}

function addGclid() {
    var gclidParam = getParam('gclid');
    var gclidFormFields = ['gclid__c']; // all possible gclid form field ids here
    var gclidRecord = null;
    var currGclidFormField;

    var gclsrcParam = getParam('gclsrc');
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    gclidFormFields.forEach(function (field) {
        if (document.getElementsByName(field)) {
            currGclidFormField = document.getElementsByName(field);
        }
    });

    if (gclidParam && isGclsrcValid) {
        gclidRecord = getExpiryRecord(gclidParam);
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
    }

    var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
    var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

    if (currGclidFormField.length > 0 && isGclidValid) {
        currGclidFormField[0].value = gclid.value;
    }

    // if gclid is set in Local Storage add it as a parameter of Trial sign up links
    if (isGclidValid) {
        addGclIdtoTrialLinks(gclid.value);
    }
}

window.addEventListener('load', addGclid);

// Check if there's any existing params in the URL
function hasParameters(url) {
    return url.indexOf('?') !== -1;  
}

// add gclid to Trial sign up links
function addGclIdtoTrialLinks(gclid) {
    const links = document.querySelectorAll('a[href*="app.taxjar.com/sign_up"]');
    for (let i = 0; i < links.length; i++) { 
        const currentHref = links[i].href;
        if (hasParameters(currentHref)) {
            var updatedHref = currentHref + '&gclid='+gclid;
        } else {
            var updatedHref = currentHref + '?gclid='+gclid;
        }
        links[i].href = updatedHref;
    }
}

//fallback to set gclid form field if it didnt happen on page load
jQuery(document).ready(function($){
    jQuery(document).on('focus','.mktoForm #FirstName', function() {
      addGclid();
    });
});